import api from "../../api/index";

const getalarms = `${process.env.VUE_APP_BASE_URI}/alarms`;

const addfencealarm = `${process.env.VUE_APP_BASE_URI}/alarms/geofence`;
const addvaluealarm = `${process.env.VUE_APP_BASE_URI}/alarms/value`;
const deleteAlarm = `${process.env.VUE_APP_BASE_URI}/alarms`;
const updatevaluealarm = `${process.env.VUE_APP_BASE_URI}/alarms/value`;
const updatefenceealarm = `${process.env.VUE_APP_BASE_URI}/alarms/geofence`;
const alarmExcursions = `${process.env.VUE_APP_BASE_URI}/alarms`;
const alarms = `${process.env.VUE_APP_BASE_URI}/alarms`;
const alarmTriggers = `${process.env.VUE_APP_BASE_URI}/alarm-triggers`;
const hardwareAlarmDevices = `${process.env.VUE_APP_BASE_URI}/hardware-alarm-devices`;

const getDefaultState = () => {
  return {
    alarms: [],
    alarm: {},
    status: "",
    alarmsMeta: {},
    alarmExcursions: [],
    alarmExcursionsMeta: {},
    alarmTriggers: [],
    alarmTriggersMeta: {},
    hardwareAlarms: [],
  };
};

const state = getDefaultState();

const getters = {
  alarms: (state) => state.alarms,
  alarm: (state) => state.alarm,
  alarmsMeta: (state) => state.alarmsMeta,
  alarmExcursions: (state) => state.alarmExcursions,
  alarmExcursionsMeta: (state) => state.alarmExcursionsMeta,
  alarmTriggers: (state) => state.alarmTriggers,
  alarmTriggersMeta: (state) => state.alarmTriggersMeta,
  hardwareAlarms: (state) => state.hardwareAlarms,
};

const actions = {
  async getalarms({ commit }, params) {
    commit("getalarms_request");
    const res = await api.get(getalarms, { params });
    if (res.data.success) {
      commit("getalarms_success", res.data.payload);
    }
    return res;
  },
  async getHardwareAlarms({ commit }, params) {
    const res = await api.get(hardwareAlarmDevices, { params });
    if (res.data.success) {
      commit("gethardwarealarms_success", res.data.payload);
    }
    return res;
  },
  async addAlarm({ commit }, data) {
    commit("getalarms_request");
    const res = await api.post(getalarms, data);
    if (res.data.success) {
      commit("getalarms_success", res.data.payload);
    }
    return res;
  },

  async getAlarmById({ commit }, id) {
    commit("getalarm_request");
    const res = await api.get(`${getalarms}/${id}`);
    if (res.data.success) {
      commit("getalarm_success", res.data.payload);
    }
    return res;
  },

  async addFenceAlarm({ commit }, newFence) {
    commit("addfence_request");
    const res = await api.post(addfencealarm, newFence);
    if (res.data.success) {
      commit("addfence_success");
    }
    return res;
  },

  async addValueAlarm({ commit }, newValue) {
    commit("addvalue_request");
    const res = await api.post(addvaluealarm, newValue);
    if (res.data.success) {
      commit("addvalue_success");
    }
    return res;
  },

  async updateAlarm({ commit }, { id, newValue }) {
    commit("updatevalue_request");
    const res = await api.patch(`${alarms}/${id}`, newValue);
    if (res.data.success) {
      commit("updatevalue_success");
    }
    return res;
  },
  async updateFenceAlarm({ commit }, { id, newValue }) {
    commit("updatefence_request");
    const res = await api.put(`${updatefenceealarm}/${id}`, newValue);
    if (res.data.success) {
      commit("updatefence_success");
    }
    return res;
  },

  async deleteAlarm({ commit }, id) {
    commit("delete_request");
    const res = await api.delete(`${deleteAlarm}/${id}`);
    if (res.data.success) {
      commit("delete_success");
    }
    return res;
  },

  async snoozeAlarms() {
    const res = await api.put(`${deleteAlarm}`);
    return res;
  },
  async snoozeAlarm(_, { id, data }) {
    console.log(id, "snooze");
    const res = await api.patch(`${alarms}/${id}/snooze`, data);
    return res;
  },

  async resetAlarmsState({ commit }) {
    await commit("resetalarmsstate_success");
  },

  async getAlarmExcursions({ commit }, { params, id }) {
    commit("getalarmexcursions_request");
    const res = await api.get(`${alarmExcursions}/${id}/excursions`, {
      params,
    });
    if (res.data.success) {
      console.log(res.data.payload, "res.data.payload)");
      commit("getalarmexcursions_success", res.data.payload);
    }
    return res;
  },

  // Fetch alarm triggers (Triggered Alarms)
  async getAlarmTriggers({ commit }, params) {
    commit("getalarmtriggers_request");
    const res = await api.get(alarmTriggers, { params });
    // Accept either { success, payload } or plain data
    if (res.data?.success && res.data?.payload) {
      commit("getalarmtriggers_success", res.data.payload);
    } else if (res.data) {
      commit("getalarmtriggers_success", res.data);
    }
    return res;
  },

  // Resolve an alarm trigger with a note
  async resolveAlarmTrigger({ commit }, { id, note }) {
    commit("resolve_alarm_trigger_request");
    const res = await api.patch(`${alarmTriggers}/${id}/resolve`, { note });
    if (res.data?.success && res.data?.payload) {
      commit("resolve_alarm_trigger_success", res.data.payload);
    } else if (res.data) {
      commit("resolve_alarm_trigger_success", res.data);
    }
    return res;
  },
};

const mutations = {
  getalarms_request: (state) => (state.status = "loading"),
  getalarms_success: (state, alarms) => {
    state.status = "success";
    state.alarms = alarms.data;
    state.alarmsMeta = alarms.meta;
  },
  gethardwarealarms_success: (state, payload) => {
    state.hardwareAlarms = payload.data;
  },
  getalarm_request: (state) => (state.status = "loading"),
  getalarm_success: (state, alarm) => {
    state.status = "success";
    state.alarm = alarm;
  },

  addfence_request: (state) => (state.status = "loading"),
  addfence_success: (state) => (state.status = "success"),

  updatevalue_request: (state) => (state.status = "loading"),
  updatevalue_success: (state) => (state.status = "success"),

  delete_request: (state) => (state.status = "loading"),
  delete_success: (state) => (state.status = "success"),

  updatefence_request: (state) => (state.status = "loading"),
  updatefence_success: (state) => (state.status = "success"),

  addvalue_request: (state) => (state.status = "loading"),
  addvalue_success: (state) => (state.status = "success"),

  getalarmexcursions_request: (state) => (state.status = "loading"),
  getalarmexcursions_success: (state, alarm) => {
    state.status = "success";
    state.alarmExcursions = alarm.data;
    state.alarmExcursionsMeta = alarm.meta;
  },

  getalarmtriggers_request: (state) => (state.status = "loading"),
  getalarmtriggers_success: (state, payload) => {
    state.status = "success";
    // Support both { data, meta } and array payloads
    if (payload && payload.data && payload.meta) {
      state.alarmTriggers = payload.data;
      state.alarmTriggersMeta = payload.meta;
    } else {
      state.alarmTriggers = Array.isArray(payload) ? payload : [];
      state.alarmTriggersMeta = {};
    }
  },

  resolve_alarm_trigger_request: (state) => (state.status = "loading"),
  resolve_alarm_trigger_success: (state, payload) => {
    state.status = "success";
    // Try to merge updated trigger into current list if present
    const updated = payload?.data || payload; // support {data} or object
    const id = updated?.id || updated?._id;
    if (!id) return;
    const idx = state.alarmTriggers.findIndex((t) => (t.id || t._id) === id);
    if (idx !== -1) {
      state.alarmTriggers.splice(idx, 1, { ...state.alarmTriggers[idx], ...updated });
    }
  },

  resetalarmsstate_success: (state) => Object.assign(state, getDefaultState()),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
